import { I18n } from '../strings-keys';
import { GridFilterDropDownStaticContent } from './gird-filter.staticTextContent.constants';
import { XuxViewSelectorStaticContent } from './xux-view-selector.constants';

export const XuxGridRowOptionsRendererStaticContent = Object.freeze({
  noOptions: I18n.Common.NoOptions,
});

export const XuxGridActionPanelStaticContent = {
  search: I18n.Common.Search,
  xuxViewSelector: XuxViewSelectorStaticContent,
  xuxPagination: Object.freeze({
    page: I18n.Common.Page,
    of: I18n.Common.of,
  }),
};

export const XuxGridStaticTextContent = Object.freeze({
  search: I18n.Common.Search,
  headerComponentParams: Object.freeze({
    all: I18n.Common.All,
  }),
  columnSelectorI18n: Object.freeze({
    noItemsToDisplay: I18n.Common.NoItemsToDisplay,
    selectAll: I18n.Common.SelectAll,
    dmGridFilterDropdown: GridFilterDropDownStaticContent,
  }),
  xuxGridActionsPanel: XuxGridActionPanelStaticContent,
  rowOptionsRenderer: XuxGridRowOptionsRendererStaticContent,
});
